import { ShopifyStore } from 'lib/commerce/shopify/shopifyHelper';

export interface CnoPlusShopifyConfig {
  Year1: {
    price: number;
    variantId: string;
  };
  Year2: {
    price: number;
    variantId: string;
    save: number; // percentage save
  };
}

export type CnoPlusShopifyMapType = {
  [key in ShopifyStore]: CnoPlusShopifyConfig;
};

// CnO Plus Shopify variant mapping
export const CnoPlusShopifyMap: CnoPlusShopifyMapType =
  process.env['NEXT_PUBLIC_ENVIRONMENT'] === 'PRODUCTION'
    ? {
        [ShopifyStore.US]: {
          // US uses ROW (Global) variants as fallback
          Year1: {
            price: 39,
            variantId: 'gid://shopify/ProductVariant/43688606662716',
          },
          Year2: {
            price: 69,
            variantId: 'gid://shopify/ProductVariant/43688606695484',
            save: 25,
          },
        },
        [ShopifyStore.IN]: {
          Year1: {
            price: 3499.99,
            variantId: 'gid://shopify/ProductVariant/44113993596998',
          },
          Year2: {
            price: 5999.99,
            variantId: 'gid://shopify/ProductVariant/44113993629766',
            save: 29,
          },
        },
        [ShopifyStore.AE]: {
          Year1: {
            price: 149.99,
            variantId: 'gid://shopify/ProductVariant/62306928460147',
          },
          Year2: {
            price: 269.99,
            variantId: 'gid://shopify/ProductVariant/62306928492915',
            save: 11,
          },
        },
        [ShopifyStore.GB]: {
          Year1: {
            price: 29.99,
            variantId: 'gid://shopify/ProductVariant/56701768434038',
          },
          Year2: {
            price: 52.99,
            variantId: 'gid://shopify/ProductVariant/56701768466806',
            save: 23,
          },
        },
        [ShopifyStore.EU]: {
          // EU shares variants with GB
          Year1: {
            price: 39.99,
            variantId: 'gid://shopify/ProductVariant/56701768434038',
          },
          Year2: {
            price: 69.99,
            variantId: 'gid://shopify/ProductVariant/56701768466806',
            save: 25,
          },
        },
        [ShopifyStore.ROW]: {
          Year1: {
            price: 39.99,
            variantId: 'gid://shopify/ProductVariant/43688606662716',
          },
          Year2: {
            price: 69.99,
            variantId: 'gid://shopify/ProductVariant/43688606695484',
            save: 25,
          },
        },
        [ShopifyStore.AU]: {
          // AU strictly reuses EU/GB variants
          Year1: {
            price: 59.99,
            variantId: 'gid://shopify/ProductVariant/56701768434038',
          },
          Year2: {
            price: 99.99,
            variantId: 'gid://shopify/ProductVariant/56701768466806',
            save: 33,
          },
        },
        [ShopifyStore.CA]: {
          // CA strictly reuses US variants (which use ROW)
          Year1: {
            price: 49.99,
            variantId: 'gid://shopify/ProductVariant/43688606662716',
          },
          Year2: {
            price: 99.99,
            variantId: 'gid://shopify/ProductVariant/43688606695484',
            save: 0,
          },
        },
        [ShopifyStore.SA]: {
          // SA uses ROW variants as placeholder
          Year1: {
            price: 172.99,
            variantId: 'gid://shopify/ProductVariant/56701768434038',
          },
          Year2: {
            price: 302.99,
            variantId: 'gid://shopify/ProductVariant/56701768466806',
            save: 25,
          },
        },
        [ShopifyStore.MX]: {
          // MX uses ROW variants as placeholder
          Year1: {
            price: 735.99,
            variantId: 'gid://shopify/ProductVariant/56701768434038',
          },
          Year2: {
            price: 1287.99,
            variantId: 'gid://shopify/ProductVariant/56701768466806',
            save: 25,
          },
        },
        [ShopifyStore.ZA]: {
          // ZA uses EU/GB variants
          Year1: {
            price: 799,
            variantId: 'gid://shopify/ProductVariant/56701768434038',
          },
          Year2: {
            price: 1399,
            variantId: 'gid://shopify/ProductVariant/56701768466806',
            save: 25,
          },
        },
        [ShopifyStore.JP]: {
          // JP uses EU/GB variants
          Year1: {
            price: 5400,
            variantId: 'gid://shopify/ProductVariant/56701768434038',
          },
          Year2: {
            price: 9600,
            variantId: 'gid://shopify/ProductVariant/56701768466806',
            save: 11,
          },
        },
      }
    : {
        [ShopifyStore.US]: {
          Year1: {
            price: 39.99,
            variantId: 'gid://shopify/ProductVariant/43688606662716',
          },
          Year2: {
            price: 69.99,
            variantId: 'gid://shopify/ProductVariant/43688606662716',
            save: 12,
          },
        },
        [ShopifyStore.IN]: {
          Year1: {
            price: 3499.99,
            variantId: 'gid://shopify/ProductVariant/43688606662716',
          },
          Year2: {
            price: 5999.99,
            variantId: 'gid://shopify/ProductVariant/43688606662716',
            save: 14,
          },
        },
        [ShopifyStore.AE]: {
          Year1: {
            price: 149.99,
            variantId: 'gid://shopify/ProductVariant/43688606662716',
          },
          Year2: {
            price: 269.99,
            variantId: 'gid://shopify/ProductVariant/43688606662716',
            save: 10,
          },
        },
        [ShopifyStore.GB]: {
          Year1: {
            price: 29.99,
            variantId: 'gid://shopify/ProductVariant/43688606662716',
          },
          Year2: {
            price: 52.99,
            variantId: 'gid://shopify/ProductVariant/43688606662716',
            save: 11,
          },
        },
        [ShopifyStore.EU]: {
          Year1: {
            price: 39.99,
            variantId: 'gid://shopify/ProductVariant/43688606662716',
          },
          Year2: {
            price: 69.99,
            variantId: 'gid://shopify/ProductVariant/43688606662716',
            save: 12,
          },
        },
        [ShopifyStore.ROW]: {
          Year1: {
            price: 39.99,
            variantId: 'gid://shopify/ProductVariant/43688606662716',
          },
          Year2: {
            price: 69.99,
            variantId: 'gid://shopify/ProductVariant/43688606662716',
            save: 15,
          },
        },
        [ShopifyStore.AU]: {
          Year1: {
            price: 59.99,
            variantId: 'gid://shopify/ProductVariant/43688606662716',
          },
          Year2: {
            price: 99.99,
            variantId: 'gid://shopify/ProductVariant/43688606662716',
            save: 17,
          },
        },
        [ShopifyStore.CA]: {
          Year1: {
            price: 49.99,
            variantId: 'gid://shopify/ProductVariant/43688606662716',
          },
          Year2: {
            price: 99.99,
            variantId: 'gid://shopify/ProductVariant/43688606662716',
            save: 0,
          },
        },
        [ShopifyStore.SA]: {
          // SA not available yet - using test variant as placeholder
          Year1: {
            price: 150,
            variantId: 'gid://shopify/ProductVariant/43688606662716',
          },
          Year2: {
            price: 260,
            variantId: 'gid://shopify/ProductVariant/43688606662716',
            save: 12,
          },
        },
        [ShopifyStore.MX]: {
          // MX not available yet - using test variant as placeholder
          Year1: {
            price: 150,
            variantId: 'gid://shopify/ProductVariant/43688606662716',
          },
          Year2: {
            price: 260,
            variantId: 'gid://shopify/ProductVariant/43688606662716',
            save: 12,
          },
        },
        [ShopifyStore.ZA]: {
          // ZA uses test variant
          Year1: {
            price: 799,
            variantId: 'gid://shopify/ProductVariant/43688606662716',
          },
          Year2: {
            price: 1399,
            variantId: 'gid://shopify/ProductVariant/43688606662716',
            save: 12,
          },
        },
        [ShopifyStore.JP]: {
          // JP uses test variant
          Year1: {
            price: 5400,
            variantId: 'gid://shopify/ProductVariant/43688606662716',
          },
          Year2: {
            price: 9600,
            variantId: 'gid://shopify/ProductVariant/43688606662716',
            save: 11,
          },
        },
      };
